import React from 'react';
import { Spinner, Table } from 'react-bootstrap';
import RenderPagination from '../../../../components/molecules/pagination';
import useRenderDexData from './hooks';
import {
  classNameHeader, renderDate, renderStatusService,
} from './utils';
import { Pencil } from '../../../../components/atoms/icons';
import { getDaysRange } from '../../../../components/atoms/func';
import LandingHeader from '../../../../components/layout/header/landing';

function RenderTableDexData() {
  const { page, dex, vmData } = useRenderDexData();

  function formatNumber(num : number | null) {
    if (num != null) { // Check if num is not null or undefined
      return (num / 100).toFixed(2); // Perform the operation and return the result
    }
    return null; // Return null if num is null or undefined
  }

  return (
    <div className="py-4">
      <LandingHeader title="Dex Cash Reading" />
      <div className={vmData ? 'd-flex align-items-center fz-14 ps-4 ps-xl-5 mb-4' : 'd-none'}>
        <div className="me-2 me-lg-3 me-xl-4">
          <div className="color-placeholder fw-bold mb-1">DEVICE ID</div>
          <div>{vmData?.deviceId}</div>
        </div>
        <div className="me-2 me-lg-3 me-xl-4">
          <div className="color-placeholder fw-bold mb-1">MACHINE MODEL</div>
          <div>{vmData?.model}</div>
        </div>
        <div className="me-2 me-lg-3 me-xl-4">
          <div className="color-placeholder fw-bold mb-1">CLIENT</div>
          <div>{vmData?.clientName}</div>
        </div>
        <div className="me-2 me-lg-3 me-xl-4">
          <div className="color-placeholder fw-bold mb-1">LOCATION</div>
          <div>{vmData?.location}</div>
        </div>
      </div>
      <div className="px-4 px-xl-5">
        <div className="w-100 mt-4">
          <div
            className="border border-1 border-color-stroke w-100 mb-4 py-2"
            style={{ borderRadius: '20px' }}
          >
            <Table borderless responsive>
              <thead>
                <tr>
                  <th className={`${classNameHeader} ps-4 ps-xl-5`}>TRANSACTION DATE</th>
                  <th className={classNameHeader}>CASH METER</th>
                  <th className={classNameHeader}>CARD SALES</th>
                  <th className={classNameHeader}>CASH IN</th>
                  <th className={classNameHeader}>BILL IN</th>
                  <th className={classNameHeader}>COINS TO CASHBOX</th>
                  <th className={classNameHeader}>COINS TO TUBES</th>
                  <th className={classNameHeader}>CHANGER VALUE</th>
                </tr>
              </thead>
              <tbody>
                {(() => {
                  if (dex.load) {
                    return (
                      <tr>
                        <td colSpan={7} className="text-center">
                          <div className="my-2"><Spinner animation="border" /></div>
                        </td>
                      </tr>
                    );
                  } if (dex.data && dex.data?.length) {
                    return dex.data.map((data, i) => (
                      <tr
                        // eslint-disable-next-line react/no-array-index-key
                        key={i}
                        className={i % 2 !== 0 ? 'bg-solid align-middle' : 'align-middle'}
                        style={{ height: '50px' }}
                      >
                        <td className="fz-14" style={{ minWidth: 170 }}>
                          <div className="ps-4 ps-xl-5">{data.transactionDate}</div>
                        </td>
                        <td>{formatNumber(data.salesHistory)}</td>
                        <td className="fz-14">{formatNumber(data.cardSales)}</td>
                        <td className="fz-14">{formatNumber(data.cashIn)}</td>
                        <td className="fz-14">{data.billsIn}</td>
                        <td className="fz-14">{formatNumber(data.coinsToCashBox)}</td>
                        <td className="fz-14" style={{ minWidth: 150 }}>{formatNumber(data.coinsToTubes)}</td>
                        <td className="fz-14" style={{ minWidth: 120 }}>{formatNumber(data.changerValue)}</td>
                      </tr>
                    ));
                  }
                  return (
                    <tr>
                      <td colSpan={7} className="text-center fz-14">
                        <div className="my-2">Data Not Found</div>
                      </td>
                    </tr>
                  );
                })()}
              </tbody>
            </Table>
            <div className="d-flex align-items-center justify-content-end mt-4 pe-4 pe-xl-5">
              <RenderPagination
                currentPage={page.current}
                setCurrentPage={page.setCurrent}
                totalPage={dex.totalPages}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(RenderTableDexData);
